// create an object with 1 level structure.

import { getDefaultValueByProperty } from '.';

// object will contain only name properties.
export function getFlatObject(propertyDescription: any, result: Record<string, string | boolean | null>): Record<string, string | boolean | null> {
    for (let propertyDescriptionKey in propertyDescription) {
        if (propertyDescription[propertyDescriptionKey]['properties']) {
            result = { ...result, ...getFlatObject(propertyDescription[propertyDescriptionKey]['properties'], result) };
        } else {
            let defaultValue = getDefaultValueByProperty(propertyDescription[propertyDescriptionKey]);
            let propertyName = propertyDescription[propertyDescriptionKey]['name'];

            result = { ...result, [propertyName]: defaultValue };
        }
    }

    return result;
}